import styled from "styled-components";

export const BigRowWrapper = styled.div`
	position: relative;
	justify-content: space-between;
	display: flex;
	flex-direction: row;
	align-items: center;
	border-bottom: 1px solid ${({ theme }) => theme.colors.lightergray};
`;

export const BigRow = styled.div<{ onClick?: () => void }>`
	cursor: ${({ onClick }) => (onClick ? "pointer" : "initial")};
	display: flex;
	align-items: center;
	padding: 30px 0;

	> :first-child {
		width: 50px;
		height: 50px;
		border-radius: 25px;
		margin-right: 26px;
	}
`;
